/**
 * Parses a UTC date string (without timezone indicator 'Z') and converts it
 * to a JavaScript Date object that automatically adjusts to the browser's
 * local timezone.
 * 
 * @param dateString - Date string in UTC format without timezone indicator
 * @returns Date object with the date interpreted as UTC
 * 
 * @example
 * // If the server sends "2024-11-04 15:30:00" (UTC)
 * const date = parseUTCDate("2024-11-04 15:30:00");
 * // JavaScript interprets the date as UTC and converts it to your local timezone
 */
export function parseUTCDate(dateString) {
  if (!dateString) return new Date();
  
  // Add 'Z' at the end if not present to indicate it's UTC
  const dateStr = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
  return new Date(dateStr);
}

